import React, { useState, useEffect } from 'react';
import axios from '../../api/api';
import { useParams } from 'react-router-dom';
import ClientUsers from './ClientUsers'
import ClientAccounts from './ClientAccounts'
import ClientMpesa from './ClientMpesa'
import ClientBank from './ClientBank'
import ClientSuccessful from './ClientSuccessful'
import ClientFailed from './ClientFailed'

const ViewClient = () => {

  const [viewClient, setViewClient] = useState('');
  const { id } = useParams();

  // getting client details by id
  useEffect(() => {
    const getClientById = async () => {
      try {
        const response = await axios.get(`/clients/${id}`);
        setViewClient(response.data);
      } catch (error) {
        console.error('Error fetching client:', error);
      }
    };
    getClientById();
  }, [id]);

  // user details
  const currentUser = window.localStorage.getItem('token');
  const user = JSON.parse(currentUser).data.user_data;

  return (
    <div className='mx-auto p-4'>
      <section className='bg-white rounded-lg p-4 mb-4'>
        <h3 className='text-center text-[#165277] font-bold mb-4'><u>Company Name : {viewClient.company_name}</u></h3>
        <div className='grid grid-cols-2 gap-4 py-2 md:grid-cols-3 2xl:grid-cols-5'>
          <div>
            <span className='font-bold'>Company Name : </span>
            {viewClient.company_name}
          </div>
          <div>
            <span className='font-bold'>User Name : </span>
            {viewClient.user_name}
          </div>
          <div>
            <span className='font-bold'>Registered Address : </span>
            {viewClient.address}
          </div>
          <div>
            <span className='font-bold'>First Name : </span>
            {viewClient.first_name}
          </div>
          <div>
            <span className='font-bold'>Last Name : </span>
            {viewClient.last_name}
          </div>
          <div>
            <span className='font-bold'>Email : </span>
            {viewClient.email_address}
          </div>
          <div>
            <span className='font-bold'>Phone Number: </span>
            {viewClient.phone_number}
          </div>
          <div>
            <span className='font-bold'>Address : </span>
            {viewClient.address}
          </div>
          <div>
            <span className='font-bold'>City : </span>
            {viewClient.city}
          </div>
          <div>
            <span className='font-bold'>State : </span>
            {viewClient.state}
          </div>
        </div>
      </section>

      <div role="tablist" className="tabs tabs-bordered overflow-x-auto">
        {/* client users */}
        <input type="radio" name="my_tabs_1" role="tab" className="tab checked:font-bold checked:text-[#165277]" aria-label="Users" defaultChecked />
        <div role="tabpanel" className="tab-content">
          <ClientUsers />
        </div>

        {/* client service accounts */}
        <input type="radio" name="my_tabs_1" role="tab" className="tab checked:font-bold checked:text-[#165277] whitespace-nowrap" aria-label="Service Clients" />
        <div role="tabpanel" className="tab-content">
          <ClientAccounts />
        </div>

        {(user.role === 'SYSTEM_ADMIN' || user.role === 'FINANCE') && (
          <>
            {/* client mpesa topups */}
            <input type="radio" name="my_tabs_1" role="tab" className="tab checked:font-bold checked:text-[#165277] whitespace-nowrap" aria-label="Mpesa Topups" />
            <div role="tabpanel" className="tab-content">
              <ClientMpesa />
            </div>

            {/* client bank topups */}
            <input type="radio" name="my_tabs_1" role="tab" className="tab checked:font-bold checked:text-[#165277] whitespace-nowrap" aria-label="Bank Topups" />
            <div role="tabpanel" className="tab-content">
              <ClientBank />
            </div>
          </>
        )}

        

        {/* client sucessful requests */}
        <input type="radio" name="my_tabs_1" role="tab" className="tab checked:font-bold checked:text-[#165277] whitespace-nowrap" aria-label="Successful Requests" />
        <div role="tabpanel" className="tab-content">
          <ClientSuccessful />
        </div>

        {/* client failed requests */}
        <input type="radio" name="my_tabs_1" role="tab" className="tab checked:font-bold checked:text-[#165277] whitespace-nowrap" aria-label="Failed Requests" />
        <div role="tabpanel" className="tab-content">
          <ClientFailed />
        </div>

      </div>
    </div>
  );
};

export default ViewClient;
